<div [formGroup]="parent">
  @if (showLetterHeaders) {
    @for (header of headers; track header) {
      <div [ngClass]="{ 'group-margin': showLetterHeaders }" class="avoid-column-break">
        <div class="letter-header">{{ header.letter }}</div>
        @for (checkbox of getItemsByHeader(header.letter); track checkbox; let i = $index) {
          <checkbox-category
            [branch]="parent.controls[header.firstIndex + i].controls"
            [data]="checkbox"
            [index]="header.firstIndex + i"
            [instance]="instance"
            [isFlat]="isFlat"
            [name]="name"
            [parentForm]="parent"
          ></checkbox-category>
        }
      </div>
    }
  } @else {
    @for (control of parent.controls; track control; let i = $index) {
      <checkbox-category
        [branch]="control.controls"
        [data]="checkboxes[i]"
        [index]="i"
        [instance]="instance"
        [isColumnBreakBefore]="columns && isColumnBreakBefore(i)"
        [isFlat]="isFlat"
        [name]="name"
        [parentForm]="parent"
      ></checkbox-category>
    }
  }
</div>
